import {
  fetchAll,
  fetchFiltered,
  show,
  addInfractionType,
  edit,
} from "@/api/infractiontype";

const state = {
  all: [],
  isLoading: false,
  infractionTypeById: null,
};

const actions = {
  cleanState({ commit }) {
    commit("cleanState");
  },

  async fetchById({ dispatch, commit }, id) {
    try {
      dispatch(
        "overlay/show",
        { isShow: true, message: "Buscando Tipo de Infração ..." },
        { root: true }
      );
      commit("setLoading", true);

      const infractionType = await show(id);
      commit("setInfractionTypeById", infractionType);
    } catch (e) {
      dispatch("notify/error", e, { root: true });
    } finally {
      dispatch("overlay/show", false, { root: true });
      commit("setLoading", false);
    }
  },

  async fetchAll({ dispatch, commit }) {
    try {
      dispatch(
        "overlay/show",
        { isShow: true, message: "Carregando Tipos de Infrações ..." },
        { root: true }
      );
      commit("setLoading", true);

      const infractionsTypes = await fetchAll();

      commit("setAll", infractionsTypes);
    } catch (e) {
      dispatch("notify/error", e, { root: true });
    } finally {
      dispatch("overlay/show", false, { root: true });
      commit("setLoading", false);
    }
  },

  async fetchFiltered({ dispatch, commit }, queriesParams) {
    try {
      const infractionsTypes = await fetchFiltered(queriesParams);
      commit("setAll", infractionsTypes);
    } catch (e) {
      dispatch("notify/error", e, { root: true });
    }
  },

  async create({ dispatch, commit }, data) {
    try {
      dispatch(
        "overlay/show",
        { isShow: true, message: "Criando Tipo de Infração ..." },
        { root: true }
      );
      commit("setLoading", true);

      await addInfractionType(data);

      return true;
    } catch (e) {
      dispatch("notify/error", e, { root: true });

      return false;
    } finally {
      dispatch("overlay/show", false, { root: true });
      commit("setLoading", false);
    }
  },

  async edit({ dispatch, commit }, { id, data }) {
    try {
      dispatch(
        "overlay/show",
        { isShow: true, message: "Editando Tipo de Infração ..." },
        { root: true }
      );
      commit("setLoading", true);

      await edit(id, data);

      return true;
    } catch (e) {
      dispatch("notify/error", e, { root: true });

      return false;
    } finally {
      dispatch("overlay/show", false, { root: true });
      commit("setLoading", false);
    }
  },
};

const mutations = {
  setAll(state, lastPositions) {
    state.all = lastPositions;
  },

  setInfractionTypeById(state, infractionType) {
    state.infractionTypeById = infractionType;
  },

  setLoading(state, isLoading) {
    state.isLoading = isLoading;
  },

  cleanState(state) {
    state.all = [];
    state.isLoading = false;
    state.infractionTypeById = null;
  },
};

export default {
  namespaced: true,
  state,
  actions,
  mutations,
};
